export const ENTITY = "MANDATORY_REQUIREMENT";

export const MANDATORY_CATEGORY_TYPE = {
   OKED: 'OKED',
   ORGANIZATION_STATS: 'ORGANIZATION_STATS'
}